import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchEXHS } from '../actions/exhs';

class Marker extends React.Component {
  constructor(props) {
    super(props);
    this.addDisplay = this.addDisplay.bind(this);
    this.displayRef = React.createRef();
  }

  addDisplay() {
    if (this.displayRef.current.style.display == 'none') {
      this.displayRef.current.style.display = 'inline';
    } else {
      this.displayRef.current.style.display = 'none';
    }
  }

  render() {
    return (
      <div
        style={{
          position: 'absolute',
          transform: 'translate(0%, -100%)',
          left: '-18px',
          top: '2px',
        }}
        onClick={this.addDisplay}
      >
        <p
          style={{
            backgroundColor: 'white',
            border: '1px solid black',
            textAlign: 'center',
            display: 'none',
            fontSize: '2em',
          }}
          ref={this.displayRef}
        >
          {this.props.exh.title}
        </p>
        <input
          type="image"
          src="/images/icon-map-amh.svg"
          width="36"
          height="36"
        />
      </div>
    );
  }
}

class ExhMap extends Component {
  static propTypes = {
    exhs: PropTypes.array.isRequired,
  };
  static defaultProps = {
    exhs: [],
  };

  constructor(props) {
    super(props);

    const caseId = document.getElementById('exh-case').dataset.id;
    this.state = {
      map: null,
      maps: null,
      located: false,
      caseId,
    };

    const { dispatch } = this.props;
    dispatch(fetchEXHS(caseId));
  }

  componentDidUpdate() {
    const { dispatch } = this.props;
    const { located } = this.state;
    const { exhs } = this.props;

    if (!located && this.map) {
      this.map.panTo(new window.google.maps.LatLng(exhs[0].lat, exhs[0].long));
      this.setState({ located: true });
    }
  }

  render() {
    const { exhs } = this.props;

    let center = null;
    let defaultLat = 53.4635776246581;
    let defaultLng = 9.98670961925282;
    center = {
      lat: parseFloat(document.getElementById('exh-case').dataset.lat),
      lng: parseFloat(document.getElementById('exh-case').dataset.long),
    };

    return (
      <>
        <div
          className="menu-container"
          style={{
            height: '40px',
            padding: '5px 0.5rem',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <a
            className="back-button"
            href={'/de/exhs/' + document.getElementById('exh-case').dataset.id}
            style={{}}
          >
            Zurück
          </a>
          <h3 className="map-title" style={{ color: 'white' }}>
            {document.getElementById('exh-case').dataset.title}
          </h3>
        </div>

        <div
          className="map-container"
          style={{
            height: 'calc(100% - 50px)',
            width: '100%',
            margin: '0',
            padding: '0',
          }}
        >
          <GoogleMapReact
            bootstrapURLKeys={{
              key: 'AIzaSyDb1klNSiqK5lic4w36n0EzCW-Fi1qpi28',
            }}
            defaultCenter={{ lat: defaultLat, lng: defaultLng }}
            center={center}
            defaultZoom={15}
            options={{ fullscreenControl: false }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map }) => {
              this.map = map;
            }}
          >
            {exhs.map(exh => (
              <Marker exh={exh} key={exh.id} lat={exh.lat} lng={exh.long} />
            ))}
          </GoogleMapReact>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  exhs: state.exhs,
});

export default connect(mapStateToProps)(ExhMap);
